import { gql } from '@apollo/client';

export const VIEW_QUOTE_HEALTH = gql`
  query viewQuote($input: viewQuoteInput) {
    viewQuote(input: $input) {
      existingPolicyNumber
      isExistingEmployee
      lob {
        lobCode
        lobName
      }
      product {
        productCode
        productName
      }
      intermediaryDetails {
        code
        name
        location
        fieldUserCode
        fieldUserName
      }
      quoteCreationDate
      quoteStatus
      proposalNumber
      customer {
        bank_detail {
          ifsc_code
          branch_name
          name
          acc_holder
          micr_code
          acc_number
        }
        cust_number
        cust_ref_number
        cust_type {
          code
          value
        }
        indv_detail {
          title {
            code
            value
          }
          gender {
            code
            value
          }
          occupation {
            code
            value
          }
          nationality {
            code
            value
          }
          marital_status {
            code
            value
          }
          first_name
          surname
          middle_name
          full_name
          date_of_birth
          id_proof_type {
            code
            value
          }
          id_proof_number
          pan_card_number
          gst_number
        }
        org_detail {
          org_name
          org_type {
            code
            value
          }
          contact_name
          reg_number
          tan_number
          gst_number
        }
        permanent_address {
          address_line1
          address_line2
          address_line3
          land_mark
          state
          district
          city
          pin_code
        }
        communication_address {
          address_line1
          address_line2
          address_line3
          land_mark
          city
          district
          state
          pin_code
        }
        comm_equal_perm
        contact {
          mobile
          email
          fax_number
          telephone
          alt_telephone
          alt_mobile
        }
      }
      quotationType
      quoteNumber
      members {
        relationship
        gender
        age
        dob
      }
      location {
        pincode
        city
        state
        zone
        district
      }
      cover {
        type
        tenure
        sumInsured
      }
      plans {
        name
        code
        covers {
          name
          index
        }
        packs {
          name
          index
          addOnCovers {
            name
            index
            selected
          }
        }
        premium {
          basePremium
          loadingDiscount
          netPremium
          gst
          stampDuty
          totalPremium
          loading {
            name
            amount
          }
          discount {
            name
            amount
          }
          breakup {
            relationship
            age
            gender
            premium
          }
        }
      }
      deductSumInsured
    }
    genderList {
      code
      value
    }
  }
`;
export const INTERMEDIARY_LIST = gql`
  query IntermediaryList {
    myIntermediaries {
      intermediaryName
      intermediaryCode
      isSelected
      businessLocations {
        code
        name
      }
    }
  }
`;
export const CHECKAUTH_QUERY = gql`
  query {
    checkAuth {
      userProfileName
      authenticated
      lastLogin
      role {
        roleName
        permissions {
          resourcePermission
        }
        permissionType
      }
    }
  }
`;
export const LOB_PRODUCT_LIST = gql`
query lobProductList {
  lobProductList {
    lob_name
    lob_code
    lob_short_name
    category
    products {
      product_name
      product_code
      product_category
      product_types {
        code
        value
      }
      linkTo
    }
  }
}
`;
export const META_QUERIES = gql`
  query metaQueries(
    $productCode: StrictNumber
    $productType: String
  ) {
    lobProductList {
      lob_name
      lob_code
      products {
        product_name
        product_code
        product_types {
          code
          value
        }
        linkTo
      }
    }
    getTwoWheelerBusinessType(
      filter: { productCode: $productCode, productType: $productType }
    ) {
      code
      value
    }
    PRD_TotalClaimCountList(productCode: $productCode) {
      code
      value
    }
    PRD_PreviousPolicyTermList(productCode: $productCode) {
      code
      value
    }
  }
`;
export const VIEW_QUOTE_TW = gql`
  query viewQuoteTW($input: viewQuoteInput) {
    viewQuoteTW(input: $input) {
      quoteNumber
      quoteCreationDate
      quoteStatus
      proposalNumber
      quoteConversionDate
      quotePdf
      QuotationRecordNo
      businessType
      intermediaryDetails {
        code
        name
        location
        fieldUserCode
        fieldUserName
      }
      disableNCB
      customer {
        cust_type {
          code
          value
        }
        is_blackListed
        cust_number
        cust_ref_number
        bank_detail {
          name
          branch_name
          ifsc_code
          acc_number
          acc_holder
          micr_code
          bank_code
          branch_code
          branch_address
        }
        contact {
          telephone
          mobile
          email
          fax_number
          alt_telephone
          alt_mobile
        }
        indv_detail {
          title {
            code
            value
          }
          first_name
          middle_name
          surname
          full_name
          gender {
            code
            value
          }
          date_of_birth
          marital_status {
            code
            value
          }
          occupation {
            code
            value
          }
          nationality {
            code
            value
          }
          driving_license_number
          id_proof_type {
            code
            value
          }
          id_proof_number
          pan_card_number
          gst_number
          employeeNumber
        }
        org_detail {
          org_type {
            code
            value
          }
          org_name
          reg_number
          tan_number
          gst_number
          contact_name
          contact_mob
          contact_email
        }
        permanent_address {
          address_line1
          address_line2
          address_line3
          land_mark
          city
          district
          state
          pin_code
          location
        }
        communication_address {
          address_line1
          address_line2
          address_line3
          land_mark
          city
          district
          state
          pin_code
          location
        }
        comm_equal_perm
        alert_action {
          alertCount
          alertContext {
            alert
            action
          }
        }
      }
      lob {
        lobCode
        lobName
      }
      product {
        productCode
        productName
      }
      productType
      productVariant
      location {
        pincode
        state
        city
        district
        zone
      }
      vehicleDetails {
        make {
          code
          value
        }
        model {
          code
          value
        }
        variant {
          code
          value
        }
        fuelType
        seatingCapacity
        cubicCapacity
        segmentType
        carryingCapacity
        gvw
        carriageType{
          code
          value
        }
        usageType{
          code
          value
        }
        typeofCarriage{
          code
          value
        }
       typeOfBody
        permitType{
          code
          value
        }
        vehicleuse{
          code
          value
        }
        typeOfMiscVehicle{
          code
          value
        }
        natureofgoods{
          code
          value
        }
        vehiclesubType{
          code
          value
        }
        rto {
          rtoAuthCode
          rtoLocCode
          rtoLocDesc
        }
        manufactureYear
        regPurchaseDate
        engineNumber
        chasisNumber
        financerName
        prevInsurance {
          insurerName
          policyNumber
          expiryDate
          startDate
          coverType
          policyTenure
        }
        vehicleAge
        registrationNumber
        zoopCustDtls {
          custName
          custContactNo
          custAddress
          custEmail
          custPincode
        }
      }
      trailerDetails{
        make
        model
        regnumber
        ChassisNumber
        SI
        yearofmanufacture
      }
      rtoDetails {
        rtoAuthCode
        rtoLocCode
        rtoLocDesc
      }
      TP_Policy_Tenure
      TP_Start_Date
      TP_End_Date
      coverDisable
ConcoverDisable
coverRTIDisable
coverEngineeDisable
      isPreviousPolicy
      previousPolicy {
        insurerName
        policyNumber
        expiryDate
        startDate
        coverType
        policyTenure
      }
      previousClaims {
        totalClaimCount
        claimsInYear1
        claimsInYear2
        claimsInYear3
        prevNCBSlab
        totalClaimAmount
        claimFreeYear
      }
      financerName
      insuredDeclaredValue {
        suggestedIDV
        minSuggestedIDV
        maxSuggestedIDV
        irfPctMin
        idvPctMin
        irfPctMax
        idvPctMax
        firstYearIDV
      }
      irf1
      adjustmentIRF2
      IRF2comments
      creditScoreDetials {
        discountOpted
        idProofType
        idProofNumber
        creditScore
        firstName
        lastName
        mobileNo
        proposerDOB
      }
      tenure
      riskCovers {
        riskType
        covers {
          name
          index
          selected
          attributes {
            name
            value
            displayName
            fieldType
            fieldDataType
            defaultValue
            showOnScreen
            dataValues {
              code
              value
            }
          }
        }
      }
      premiumBreakup {
        idv1
        idv2
        idv3
        tenure
        netODPremium
        netTPPremium
        loadingDiscount
        netPremium
        gst
        stampDuty
        totalPremium
        loading {
          name
          amount
        }
        discount {
          name
          amount
        }
        claimFreeYear
        creditScore
        NCB
        clutchProtSI
        clutchProtRate
        clutchProtPremium
      }
      voluntaryDeductibleAmt
      NCB
      isTrailerRequired
      nooftrailers
      towedby
      totalIDV
      bodyIDV
      changedGVW
      coverforlamps
      coverforprivateandcommercial
      vehicleusedlimitedtoownpremises
      vehicleuseddrivingtuitions
      ImportedVehicle
      ConfinedtoOwnPremises
      SoftCopyDiscount
      AntiTheftDiscount
      isQuoteSavingWOCust
      QuoteSavingWOCustIndex
      policy {
        startDate
        expiryDate
      }
    }
  }
`;
export const VIEW_QUOTE_FIRE_SA = gql`
  query viewQuoteFireSA($input: FireViewQuoteInput) {
    viewQuoteFireSA(input: $input) {
      quoteNumber
      quoteCreationDate
      status
      basisOfValuation
      productKg
      proposalNumber
      stageIndex
      otherDetails 
      { 
        premisesRentedOut
        ownerOccupant
      }
      loadingAndDiscount 
      { 
        discountPercentage
         loadingPercentage 
         }
         eqZone
          locationCode
          pinCodeLocality
          city
      district
      pincode
      state
      underwriterMsg
      customerDetails
          {
            customerType{
            code
            value
            },
            orgInsuredName
            firstName
            middleName
            lastName
          }
      customer {
        bank_detail {
          ifsc_code
          branch_name
          name
          acc_holder
          micr_code
          acc_number
        }
        cust_number
        cust_ref_number
        cust_type {
          code
          value
        }
        indv_detail {
          title {
            code
            value
          }
          gender {
            code
            value
          }
          occupation {
            code
            value
          }
          nationality {
            code
            value
          }
          marital_status {
            code
            value
          }
          first_name
          surname
          middle_name
          full_name
          date_of_birth
          id_proof_type {
            code
            value
          }
          id_proof_number
          pan_card_number
          gst_number
        }
        org_detail {
          org_name
          org_type {
            code
            value
          }
          contact_name
          reg_number
          tan_number
          gst_number
        }
        permanent_address {
          address_line1
          address_line2
          address_line3
          land_mark
          state
          district
          city
          pin_code
        }
        communication_address {
          address_line1
          address_line2
          address_line3
          land_mark
          city
          district
          state
          pin_code
        }
        comm_equal_perm
        contact {
          mobile
          email
          fax_number
          telephone
          alt_telephone
          alt_mobile
        }
      }
      lob {
        lobCode
        lobName
      }
      product {
        productCode
        productName
      }
      businessOfInsured
      prevClaimExpDtls {
        anyPrevClaimsExp
        prevClaimExpDesc
      }
      policyType
      tenure {
        code
        value
      }
      policyStartDate
      policyExpiryDate
      geographicalArea
      clauses {
        default
        userDefined
        Description
        ClauseCode
        ClauseNumber
      }
      exclusions {
        default
        userDefined
        Description
        ExclusionCode
        ExclusionNumber
      }
      warranties {
        default
        userDefined
        Description
        WarrantyCode
        WarrantyNumber
      }
      conditions {
        default
        userDefined
        Description
        ConditionCode
        ConditionNumber
      }
      uploadedDocuments {
        documentType {
          code
          value
        }
        documentName
        documentSize
        base64EncodedDoc
      }
      underwriterComment
      riskCovers {
        riskType
        covers {
          name
          index
          selected
          attributes {
            name
            value
            displayName
            fieldType
            fieldDataType
            defaultValue
            showOnScreen
            dataValues {
              code
              value
            }
          }
        }
      }
      riskLocations {
        riskLocationID
        occupancyCodeValue {
          code
          value
          occupancySection
          occupancyRate
          riskCode
          rateCode
          riskGrade
          riskGradeDefinition
          riskPreference
          gicClass
          stfiRate
          rsmdRate
        }
        riskLocAddress {
          address_line1
          pin_code
          state
          city
          district
          eqZone
          locationCode
        }
        costOfConstruction
        ratePerMille
        carpetArea
        buildingValue
        additionalStructure
        totalBuildingSI
        generalContentSI
        additionalContent
        additionalContentSI
        valuableContent
        valuableContentSI
        totalContentSI
        totalSumInsured
        loadingPct
        discountPct
        premium {
          locationNetPremium
          locationGST
          locationTotalPremium
          basicRate
        }
      }
      intermediaryDetails {
        code
        name
        location
        fieldUserCode
        fieldUserName
      }
      finalisedPremium {
        locNetPremium
        locGST
        locTotalPremium
        basicRate
      }
    }
  }
`;
export const VIEW_QUOTE_FIRE = gql`
  query viewQuoteFire($input: FireViewQuoteInput) {
    viewQuoteFire(input: $input) {
      quoteNumber
      quoteCreationDate
      status
      proposalNumber
      stageIndex
      customer {
        bank_detail {
          ifsc_code
          branch_name
          name
          acc_holder
          micr_code
          acc_number
        }
        cust_number
        cust_ref_number
        cust_type {
          code
          value
        }
        indv_detail {
          title {
            code
            value
          }
          gender {
            code
            value
          }
          occupation {
            code
            value
          }
          nationality {
            code
            value
          }
          marital_status {
            code
            value
          }
          first_name
          surname
          middle_name
          full_name
          date_of_birth
          id_proof_type {
            code
            value
          }
          id_proof_number
          pan_card_number
          gst_number
        }
        org_detail {
          org_name
          org_type {
            code
            value
          }
          contact_name
          reg_number
          tan_number
          gst_number
        }
        permanent_address {
          address_line1
          address_line2
          address_line3
          land_mark
          state
          district
          city
          pin_code
        }
        communication_address {
          address_line1
          address_line2
          address_line3
          land_mark
          city
          district
          state
          pin_code
        }
        comm_equal_perm
        contact {
          mobile
          email
          fax_number
          telephone
          alt_telephone
          alt_mobile
        }
      }
      lob {
        lobCode
        lobName
      }
      product {
        productCode
        productName
      }
      businessOfInsured
      prevClaimExpDtls {
        anyPrevClaimsExp
        prevClaimExpDesc
      }
      isKutchaConstruct
      policyType
      tenure {
        code
        value
      }
      policyStartDate
      policyExpiryDate
      clauses {
        default
        userDefined
      }
      exclusions {
        default
        userDefined
      }
      warranties {
        default
        userDefined
      }
      conditions {
        default
        userDefined
      }
      uploadedDocuments {
        documentType {
          code
          value
        }
        documentName
        documentSize
        base64EncodedDoc
      }
      underwriterComment
      riskLocations {
        riskLocationID
        occupancyCodeValue {
          code
          value
          occupancySection
          occupancyRate
          riskCode
          rateCode
          riskGrade
          riskGradeDefinition
          riskPreference
          gicClass
          stfiRate
          rsmdRate
        }
        riskLocAddress {
          address_line1
          pin_code
          state
          city
          district
          eqZone
          locationCode
          isSamePremises
        }
        buildingSI
        plantMachinerySI
        furnitureFixtureSI
        rawMaterialSI
        otherContentsSI
        stockSI
        stocksInProcessSI
        stockOnFloaterBasis
        floaterLocations {
          address_line1
          pin_code
          state
          city
          district
          eqZone
          locationCode
        }
        maxStockSIAtOneLoc
        locationSI
        fireExtinguishApplisDtls {
          applianceCode
          applianceValue
          isSelected
        }
        constructionClass
        waterbodyDistance
        securityProvisions
        loadingPct
        discountPct
        prevClaimExpDesc
        premium {
          locationNetPremium
          locationGST
          locationTotalPremium
          stampDuty
        }
      }
      intermediaryDetails {
        code
        name
        location
        fieldUserCode
        fieldUserName
      }
      finalisedPremium {
        locNetPremium
        locGST
        locTotalPremium
        stampDuty
        basicRate
      }
    }
  }
`;
export const DOCUMENT_STATIC_DATA = gql`
  query documentExtensions {
    documentExtensions {
      code
      value
    }
    docFileSizeLimit {
      code
      value
    }
    #docAddLimit {
    #code
    #value
    #}
    docDescCharacterLimit {
      code
      value
    }
  }
`;